import { isString } from 'lodash';
import React, { useEffect } from 'react';
import { AlertDialog } from '../AlertDialog';
import { useToggle } from '../../hooks';
import { getPublicPath } from '../../utils';

type CacheBusterProps = {
    disabled?: boolean;
    currentVersion: string;
    newVersion: string | (() => Promise<string>);
    action: 'reload' | 'dialog';
    reloadLimit?: number;
};

export const CacheBuster: React.FunctionComponent<CacheBusterProps> = ({
    newVersion,
    currentVersion,
    disabled,
    action,
    reloadLimit = 3,
}) => {
    const timestampedUrl = getPublicPath(true);
    const [dialogOpened, toggleDialog] = useToggle(false);
    const cacheBusterReloadCountKey = 'cacheBusterReloadCount';
    const reloadCount = parseInt(sessionStorage.getItem(cacheBusterReloadCountKey) ?? '0');

    useEffect(() => {
        async function checkForNewVersion() {
            if (!disabled) {
                const fetchedNewVersion = await (isString(newVersion) ? Promise.resolve(newVersion) : newVersion());
                if (fetchedNewVersion !== currentVersion) {
                    if (action === 'dialog') {
                        toggleDialog(true);
                    } else if (reloadCount < reloadLimit) {
                        sessionStorage.setItem(cacheBusterReloadCountKey, String(reloadCount + 1));
                        window.location.replace(timestampedUrl);
                    }
                }
            }
        }
        checkForNewVersion();
        // eslint-disable-next-line react-compiler/react-compiler
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {action === 'dialog' && (
                <AlertDialog
                    noControl
                    open={dialogOpened}
                    maxWidth="md"
                    title={'New Version Available'}
                    content={'Would you like to load the new version?'}
                    positiveButton="Yes"
                    neutralButton="No"
                    neutralButtonColor="error"
                    onPositiveClick={() => {
                        window.location.replace(timestampedUrl);
                    }}
                    onNeutralClick={() => {
                        toggleDialog(false);
                    }}
                />
            )}
        </>
    );
};
